import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "title"
};
var _hoisted_2 = {
  key: 1,
  class: "list-content"
};
var _hoisted_3 = {
  class: "point-list_info"
};
var _hoisted_4 = {
  class: "point-list_type"
};
var _hoisted_5 = {
  class: "point-list_time"
};
var _hoisted_6 = {
  class: "point-list_value"
};
import StickyPowerBy from "@/components/StickyPowerBy.vue";
import { ref } from "vue";
import { getPointHistory } from "@/api/user";
import EmptyListPlaceholder from "@/components/EmptyListPlaceholder.vue";
import { useOrder } from "@/hooks/useOrder";
import { formatDateWithTZ } from "@/utils/format";
import { useI18n } from "vue-i18n";
export default {
  __name: 'PointList',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useOrder = useOrder(),
      toOrderView = _useOrder.toOrderView;
    var pageNum = ref(1);
    var pageSize = ref(10);
    var loading = ref(false);
    var finished = ref(false);
    var items = ref([]);
    var changeEventMap = {
      merchant_manual: t("merchantModification")
    };
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$data, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return getPointHistory({
                page_num: pageNum.value,
                page_size: pageSize.value
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.items) || [];
                if (data.length > 0) {
                  items.value = items.value.concat(data);
                  pageNum.value += 1;
                } else {
                  finished.value = true;
                }
              } else {
                finished.value = true;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var reset = function reset() {
      finished.value = false;
      items.value = [];
      pageNum.value = 1;
      fetchData();
    };
    __expose({
      reset: reset
    });
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createBlock(StickyPowerBy, {
        class: "point-list"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("transactionHistory")), 1), _createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
              return loading.value = $event;
            }),
            finished: finished.value,
            "loading-text": _ctx.$t('loading'),
            class: "list",
            onLoad: fetchData
          }, {
            default: _withCtx(function () {
              return [finished.value && items.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
                key: 0,
                text: _ctx.$t('youHaveNoPointsYetPlaceAnOrderNow'),
                btntext: _ctx.$t('orderNow'),
                class: "empty",
                onGo: _unref(toOrderView)
              }, null, 8, ["text", "btntext", "onGo"])) : _createCommentVNode("", true), items.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["point-list_item", {
                    'last-child': index === items.value.length - 1
                  }])
                }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(changeEventMap[item.change_event_hrf] || item.change_event_hrf), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatDateWithTZ)(item.create_at)), 1)]), _createElementVNode("div", _hoisted_6, _toDisplayString(item.change_value > 0 ? "+" + item.change_value : item.change_value), 1)], 2);
              }), 128))])) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["loading", "finished", "loading-text"])];
        }),
        _: 1
      });
    };
  }
};